// The main number's type in words, from the server's phone_type ({ type, assumed }:
// utils/person-phones mainPhoneType). The surface derives nothing: "Mobile
// (assumed)" when the server says the type was not stated (ruling 2).
// Readers: components/people/PersonIdentityForm.jsx, components/account/record/FactRow.jsx.
const TYPE_WORD = { mobile: 'Mobile', home: 'Home', office: 'Office', other: 'Other' };

export function phoneTypeWord(t) {
  if (!t || !t.type) return null;
  const word = TYPE_WORD[t.type] || t.type;
  return t.assumed ? `${word} (assumed)` : word;
}
